import ReactPlayer from "react-player";
import SimpleModal from "../SimpleModal/SimpleModal";
import { useState } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "src/app/utils/AssetHelpers";
import { useIntl } from "react-intl";

const DocumentationModal = ({ url, title }: { url: string; title: string }) => {
    const [openModal, setOpenModal] = useState(false);
    const { formatMessage } = useIntl();
    const handleModal = () => {
        setOpenModal((el) => !el);
    };
    return (
        <>
            <SVG
                onClick={handleModal}
                className="pulse-animation icon-primary cursor-pointer"
                src={toAbsoluteUrl("/media/icons/duotune/general/gen046.svg")}
            />
            <SimpleModal
                showModal={openModal}
                entityName={title || "Documentation"}
                handleClose={handleModal}
                buttonConfirmationAction={handleModal}
                buttonConfirmationLabel={formatMessage({ id: "common.action.close" })}
                formId={""}
            >
                <div className="d-flex justify-content-center">
                    <ReactPlayer
                        playing={true}
                        controls={true}
                        loop={true}
                        muted={true}
                        playsinline={true}
                        url={url}
                    />
                </div>
            </SimpleModal>
        </>
    );
};

export default DocumentationModal;
